import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, of, switchMap } from 'rxjs';



//Services
import { ToastrService } from 'ngx-toastr';
import { KeycloakService } from './keycloak.service';
import { UsuariosService } from './usuarios.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  //public
  public currentUser: Observable<any | null>;

  //private
  private currentUserSubject: BehaviorSubject<any | null>;
  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(
    private toastr: ToastrService,
    private usuariosService: UsuariosService,
    private keycloak: KeycloakService) {

    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(<string>localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  isTokenNoValid() {
    try {
      return this.keycloak.isTokenExpired();
    } catch (e) {
      return true;
    }
  }


  isTokenNoValidWithToken() {
    return this.keycloak.isTokenExpiredWithToken();
  }

  login() {
    let opciones = { idpHint: 'google' };
    return this.keycloak.createLoginUrl(opciones)
  }

  setUser() {
    console.log('setUser')
    return new Promise((resolve, reject) => {
      this.keycloak.loadUserInfo().then((user: any) => {
        console.log('user', user);
        this.usuariosService.obtenerPorEmail(user.email)
          .pipe(
            catchError((error: HttpErrorResponse) => {
              switch (error.status) {
                case 403:
                  this.toastr.info('Tu usuario debe ser activado', 'Contacte con el Administrador');
                  break;
                case 404:
                  this.toastr.info('No se encuentra el usuario', 'Contacte con el Administrador');
                  break;
                default:
                  this.toastr.info('Ocurrio un error al intentar ingresar', 'Contacte con el Administrador');
                  break;
              }
              localStorage.removeItem('currentUser');
              this.keycloak.logout();
              return of(null)
            })
          )
          .subscribe((result) => {

            const { modPerfil, ...perfilSinModPerfil } = result.perfil;

            const user = {
              ...result,
              perfil: perfilSinModPerfil,
              token: this.keycloak.getToken()
            };

            const permisos = result?.perfil.modPerfil?.map(
              (permiso: any) => permiso.modulo.modNombre
            ) || [];

            localStorage.setItem("permisos", JSON.stringify(permisos));
            localStorage.setItem("currentUser", JSON.stringify(user));
            this.currentUserSubject.next(user);
            resolve(true);
          });

      });
    })
  }

  tienePermiso(codigoPermiso: string): boolean {

    const permisos = JSON.parse(<string>localStorage.getItem("permisos"));
    if (permisos && Array.isArray(permisos)) {
      return permisos.includes(codigoPermiso);
    } else {
      return false;
    }
  }


  getToken() {
    return this.keycloak.getToken();
  }

  refreshToken() {
    return this.keycloak.refreshToken()
  }

  /**
   * User logout
   *
   */
  async logout() {
    try {
      // remove user from local storage to log user out
      localStorage.removeItem('currentUser');
      if (await this.keycloak.loadUserInfo()) {
        this.keycloak.logout();
      }
      localStorage.removeItem('permisos');
      // notify
      this.currentUserSubject.next(null);
    } catch (e) {
      this.currentUserSubject.next(null);
    }

  }

}
